<span class="phx-tile-prefix">
  <ng-content select="[phx-tile-prefix]"></ng-content>
</span>
<div class="phx-tile-content">
  <ng-content></ng-content>
</div>
<span class="phx-tile-suffix">
  <ng-content select="[phx-tile-suffix]"></ng-content>
</span>